import { Mail } from "lucide-react";

export default function FooterSection() {
  return (
    <footer data-testid="footer-section" className="py-8 bg-slate-900">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <p
              className="text-white font-bold text-lg"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Teacher Utility Toolkit
            </p>
            <p className="text-slate-400 text-sm mt-1">Built for Teachers. Made for Real School Work.</p>
          </div>
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <Mail className="w-4 h-4" />
            <a href="mailto:teacherutilitytoolkit@gmail.com" className="hover:text-white transition-colors">
              teacherutilitytoolkit@gmail.com
            </a>
          </div>
        </div>
        <div className="mt-6 border-t border-slate-800 pt-4 text-center">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} Teacher Utility Toolkit. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
